export const FAVOURITE_SORT_OPTIONS = [
    {
        key: 'NEWEST',
        value: 'Newest'
    },
    {
        key: 'OLDEST',
        value: 'Oldest'
    },
    {
        key: 'MINE',
        value: 'My Folder'
    },
    {
        key: 'SHARED',
        value: 'Share with me'
    }
]

export const FAVOURITE_TAB_CONFIG = {
    ALL: {
        id: 'ALL',
        label: 'All Folders',
        organizationTypes: ['NITEX', 'BUYER']
    },
    MY: {
        id: 'MY',
        label: 'My Folders',
        organizationTypes: ['BUYER']
    },
    NITEX: {
        id: 'NITEX',
        label: 'Nitex Provided Folders',
        organizationTypes: ['NITEX']
    }
}
